import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React from 'react';
import TextField from '@material-ui/core/TextField';

function VcamsDuplicateDialog(props) {
  const { label = '-', ewc_instance_name = '-', type = '-' } = props;
  return (
    <Dialog fullWidth maxWidth={'xs'} open={props.open}>
      <DialogContent>
        <div className='infrastructure-expanded'>
          <div className='border'>
            <h2 className="margin-bottom-none">Duplicate VCAM</h2>
            <TextField disabled label={'Primary Virtual Camera Name'} value={label} style={{width: '100%'}} />
            <TextField disabled label={'Type'} value={type} style={{width: '100%'}} />
            <TextField required disabled label='EWC' value={ewc_instance_name} style={{width: '100%'}} />
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{flexDirection: 'row', justifyContent: 'space-between', padding: '8px 24px'}}>
        <Button variant="text" onClick={() => props.onCancel()}>
          Cancel
        </Button>
        <Button variant='contained' color='primary' onClick={() => props.onOk()}>
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(VcamsDuplicateDialog);
